export const Bio = {
  name: "Ahmad Haziq",
  roles: [
    "Software Developer",
    "Fullstack Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am an Enthusiastic Web Developer Specialist with more than 1 years. Skilled in Web development, UI/UX design, and Software Engineer. Able to work with various programming languages, such as Javascript, PHP, and Java.",
  github: "https://github.com/ahmdhzq",
  resume:
    "https://drive.google.com/file/d/1j4cZKgaEln2x9iAldKHnvnR12otGMcWT/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ahmdhzq18/",
  twitter: "https://twitter.com/Ahmadha24700995",
  insta: "https://www.instagram.com/ahmd_haziqqq/",
  facebook: "https://www.facebook.com/ahmad.haziq.16503",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      }, 
      {
        name: "Tailwind",
        image:
          "https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Laravel",
        image: "https://laravel.com/img/logomark.min.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      {
        name: "Figma",
        image:
          "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://petik-jombang-next.vercel.app/logo.png",
    role: "Software Engineer",
    company: "PeTIK II Jombang",
    date: "Aug 2023 - Present",
    desc: " Build and Maintaining the website and updating features with a HTML/CSS, Laravel framework, Database MySQL and Bootsrap 5 and Teaching Web Design (HTML & CSS) ",
    skills: [
      "Figma",
      "HTML",
      "CSS",
      "Javascript",
      "Laravel",
      "Bootsrap 5",
      "Windows VPS",
      "MySQL",
    ],
  },
  {
    id: 0,
    img: "https://www.stikma.ac.id/wp-content/uploads/2023/01/logo-stikma-75x75px.png",
    role: "Fullstack Developer ",
    company: "STT Stikma International",
    date: "Mey 2023 – Aug 2023",
    desc: "Build a Website applications using HTML5 & CSS, Bootstrap 5, Laravel 10 and MySQL databases ",
    skills: [
      "Figma",
      "Laravel",
      "Bootsrap 5",
      "MySQL",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    id: 1,
    img: "https://masterprima.com/assets/img/iconmpico.png",
    role: "Frontend Developer",
    company: "LBB Masterprima Malang ",
    date: "Jun 2023 - Jul 2023",
    desc: "Build a static website company using HTML & CSS and Bootstrap 5",
    skills: [
      "Figma",
      "Bootsrap 5",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  // {
  //   id: 2,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
  //   role: "Open Source Contributor ",
  //   company: "GirlScript Summer of Code",
  //   date: "May 2023 - Present",
  //   desc: "Contributing to different open-source projects and learn from industry experts",
  //   doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  // },
];

export const education = [
  {
    id: 0,
    img: "https://akupintar.id/documents/20143/0/120061378_110520754141084_6594683579243627143_n.jpg/f6d537ed-41d1-dcfc-09fa-1b6115265875?version=1.0&t=1647482485657&imageThumbnail=1",
    school: "Asia Cyber University",
    date: "Oct 2023 - Present",
    desc: "I am currently pursuing a Bachelor's degree in Informatics Engineering at Asia Cyber University, South Jakarta. I am now entering my first semester.",
    degree: "Bachelor of Technology - Informatics Engineering ",
  },
  {
    id: 1,
    img: "https://petik-jombang-next.vercel.app/logo.png",
    school: "PeTIK II Jombang ",
    date: "Mey 2022 - Jul 2023",
    desc: "I completed my vocational school at PeTIK II Jombang, where I studied Software Engineer with GPA 3.58. I have taken courses Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Web Development.",
    degree: "Software Engineer",
  },
  {
    id: 2,
    img: "https://smkn1nganjuk.sch.id/wp-content/uploads/sb/16-11-21/19699_logoicon2.png",
    school: "SMKN 1 Nganjuk",
    date: "Apr 2019 - Apr 2022",
    desc: "I completed my class 12 high school education at SMKN 1 Nganjuk, where I studied Electrical Engineering with grade 81 and I am active in Paskibra PASOPATI.",
    degree: "Electrical Engineering ",
  },
];

export const projects = [
  {
    id: 0,
    title: "Licensing App PeTIK II Jombang",
    date: "Aug 2023 - Present",
    description:
      "License App is an internal application that students use every time they leave, Licensing App built with a HTML/CSS, Laravel framework, Database MySQL and Bootsrap 5. Licensing App deploy in Windows VPS. Licensing App have a fitur to send notification when user create a licensing and when admin approve licensing, it will send notification to Whatsapp user.",
    image:
      "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/Untitled.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Bootsrap 5",
      "Responsive Web Design",
      "Laravel",
      "MVC",
      "MySQL",
      "WPPCONNECT",
      "Windows VPS",
    ],
    category: "web app",
    github: "https://github.com/ahmdhzq",
    webapp: "http://203.194.114.235:8000/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 1,
    title: "Admin web app STT Stikma International",
    date: "Jun 2023 - Aug 2023",
    description:
      "Admin web app is an internal application that admin use to upload blog or article in main website company, Admin web app built with a HTML/CSS, Laravel framework, Database MySQL, Bootstrap 5 and CK editor 5 to use rich text editor.",
    image:
      "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/Screenshot%202023-10-23%20102444.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Bootsrap 5",
      "Responsive Web Design",
      "Laravel",
      "MVC",
      "MySQL",
    ],
    category: "web app",
    github: "https://github.com/ahmdhzq",
    webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Design UI NFT website",
    date: "Jan 2023 - Jan 2023",
    description:
      "Design UI Website is Final project learning UI/UX. I got the inspiration to create an NFT website from the NFT market.",
    image:
      "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/image.png?raw=true",
    tags: ["Figma", "UI/UX"],
    category: "machine learning",
    github: "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/image.png?raw=true",
    webapp: "https://www.figma.com/proto/NJGlBVrQjpCzcQEJH5Rlcf/Tugas-UAS-hi-fi?page-id=0%3A1&type=design&node-id=1-2&viewport=648%2C84%2C0.15&t=9A7owhuwcIKujKbx-1&scaling=min-zoom&mode=design",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 3,
    title: "Half Game Website",
    date: "Dec 2022 - Dec 2022",
    description:
      "Half Game Website is landing page to download game. Half game built with React Js. This project is final project learning javascript. When working on a project we are only given 3 days to complete everything from design to website.",
    image:
      "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/Screenshot%202023-10-23%20135141.png?raw=true",
    tags: ["React Js", "JavaScript"],
    category: "android app",
    github: "https://github.com/ahmdhzq/TUGAS-UAS",
    webapp: "https://half-game.vercel.app/",
  },
  {
    id: 10,
    title: "Portfolio React Js",
    date: "Nov 2022 - Nov 2022",
    description:
      "My first portfolio created with React js.",
    image:
      "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/Screenshot%202023-10-23%20135512.png?raw=true",
    tags: ["React Js", "JavaScript"],
    category: "android app",
    github: "https://github.com/ahmdhzq/project-react-js-portfolio",
    webapp: "https://ahzq18-react-app.vercel.app/",
  },
  {
    id: 4,
    title: "Todo Web App",
    date: "Nov 2022 - Nov 2022",
    description:
      "A Todo Web App built with HTML, CSS and Javascript. A Todo Web App is project when learning Javascript.",
    image:
      "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/Screenshot%202023-10-23%20140517.png?raw=true",
    tags: ["HTML", "CSS", "Javascript", "Local Storage"],
    category: "web app",
    github: "https://github.com/ahmdhzq/Todo-App-UTS-JS",
    webapp: "https://todo-app-uts-js.vercel.app/",
  },
  {
    id: 5,
    title: "Portfolio Tailwilnd CSS",
    date: "Nov 2022 - Nov 2022",
    description:
      "A Web Portfolio created with Tailwind, This is a website that I created by copying Mr. Sandhika Galih's YouTube tutorial video",
    image:
      "https://github.com/ahmdhzq/Backup-image-portfolio/blob/main/Screenshot%202023-10-23%20140808.png?raw=true",
    tags: ["HTML", "CSS", "Tailwind CSs"],
    category: "web app",
    github: "https://github.com/ahmdhzq/portfolio-HTML-CSS",
    webapp: "https://ahmdhzq.github.io/portfolio-HTML-CSS/",
  },
  {
    id: 9,
    title: "SILOKER Website",
    date: "Oct 2022 - Oct 2022",
    description:
      "SILOKER Website is a website for looking for work and a Final project of web design lesson build a website with html, css and bootstrap 5.",
    image:
      "https://github.com/ahmdhzq/learn-katalon-1/blob/main/Screenshot%202023-10-23%20004746.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Bootsrap 5",
      "Responsive Web Design"
    ],
    category: "web app",
    github: "https://github.com/ahmdhzq/website-siloker",
    webapp: "http://website-siloker.vercel.app/",
  },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];

export const TimeLineData = [
  { year: 2022, text: "Started my journey" },
  { year: 2022, text: "Worked as a freelance developer" },
  { year: 2022, text: "Founded JavaScript Mastery" },
  { year: 2023, text: "Shared my projects with the world" },
  { year: 2023, text: "Started my own platform" },
];
